import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${process.env.REACT_APP_API_MAINTENANCES_BASE_URL}odometers`;

async function fetchOdometers(filters = {}) {
  try {
    const queryPayload = {
      VehicleId: filters.vehicleId ?? filters.VehicleId ?? "",
      StartDate: filters.startDate ?? filters.StartDate ?? "",
      EndDate: filters.endDate ?? filters.EndDate ?? "",
    };

    const query = new URLSearchParams(
      Object.entries(queryPayload).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined,
      ),
    ).toString();

    const url = query ? `${basePath}?${query}` : basePath;
    const response = await api.get(url);

    const treated = errorHandling.handleResponse(
      response,
      "odometersService.fetchOdometers",
    );
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "odometersService.fetchOdometers");
    throw error;
  }
}

async function createOdometer(payload = {}) {
  try {
    const requestPayload = {
      VehicleId: payload.vehicleId ?? payload.VehicleId,
      VehicleOdometerId:
        payload.vehicleOdometerId ?? payload.VehicleOdometerId ?? 0,
      OdometerDateTime: payload.odometerDateTime ?? payload.OdometerDateTime,
      OdometerValue: payload.odometerValue ?? payload.OdometerValue,
    };

    const response = await api.post(basePath, JSON.stringify(requestPayload));

    const treated = errorHandling.handleResponse(
      response,
      "odometersService.createOdometer",
    );
    return treated ?? null;
  } catch (error) {
    errorHandling.cathError(error, "odometersService.createOdometer");
    throw error;
  }
}

async function deleteOdometer(id) {
  try {
    const response = await api.delete(`${basePath}/${id}`);
    errorHandling.handleResponse(response, "odometersService.deleteOdometer");
    return true;
  } catch (error) {
    errorHandling.cathError(error, "odometersService.deleteOdometer");
    throw error;
  }
}

export const odometersService = {
  fetchOdometers,
  createOdometer,
  deleteOdometer,
};
